// ─────────────────────────────────────────────────────────────────────
// «WE COULD NOT ASK» IS NOT «NOBODY IS SIGNED IN» (#1145, AUD-026).
//
// `restore()` asks the server who this browser's cookie belongs to. When the
// server could not be reached it answered `false`, exactly as for a browser
// with no cookie — so a reload while offline showed the SIGN-IN screen to
// somebody whose session was intact, and the next thing they did was try to
// sign in again against a server that was not there.
//
// The two `restore()`s note a transport failure here (a thrown fetch, or the
// gateway codes App Service answers while restarting); the gate reads it after
// a `false` and shows «no connection» with a retry instead. A LEAF module, so
// the session mocks every gate test uses leave it at its default: nothing noted.
// ─────────────────────────────────────────────────────────────────────

/** The codes App Service answers while the API is restarting. */
const GATEWAY = new Set([502, 503, 504]);

let unreachable = false;

/** A restore could not reach the server. */
export function noteRestoreUnreachable(): void {
  unreachable = true;
}

/** Note it when a restore's response is a gateway code. Returns whether it was. */
export function noteIfGateway(status: number): boolean {
  if (!GATEWAY.has(status)) return false;
  unreachable = true;
  return true;
}

/** Did a restore since the last `clearRestoreUnreachable()` fail to reach the server? */
export function restoreUnreachable(): boolean {
  return unreachable;
}

/** Called before a restore attempt, so each attempt answers for itself. */
export function clearRestoreUnreachable(): void {
  unreachable = false;
}
